import React from 'react';

const ArrowDownIcon = ({ color = '#A6B0CF' }) => (
  <svg
    className="arrow"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.25 7.62774C14.2503 7.73979 14.2256 7.8505 14.1776 7.95173C14.1296 8.05297 14.0595 8.14216 13.9725 8.21274L9.47246 11.8352C9.33826 11.9456 9.16993 12.0059 8.99621 12.0059C8.82249 12.0059 8.65416 11.9456 8.51996 11.8352L4.01996 8.08524C3.8668 7.95794 3.77048 7.77501 3.7522 7.57669C3.73391 7.37837 3.79516 7.18091 3.92246 7.02774C4.04977 6.87458 4.2327 6.77826 4.43102 6.75998C4.62934 6.74169 4.8268 6.80294 4.97996 6.93024L8.99996 10.2827L13.02 7.04274C13.1301 6.95103 13.2641 6.89277 13.4063 6.87486C13.5484 6.85695 13.6927 6.88014 13.8221 6.94168C13.9515 7.00323 14.0606 7.10055 14.1364 7.22213C14.2122 7.34371 14.2516 7.48447 14.25 7.62774Z" />
  </svg>
);

export default ArrowDownIcon;
